var ResizeFonts = function () {
    var self = {
        selectors: {
            baseFontSize: "16px",
            resizingStep: 2,
            minFontSize: 10,
            maxFontSize: 26,
        },
        init: function () {
            if (typeof localStorage.fontSize !== 'undefined') {
                $("html").css("font-size", localStorage.fontSize);
            }

            $("[data-action='increase-font']").click(function () {
                let fontSize = (self.getSize() + self.selectors.resizingStep);

                if (fontSize <= self.selectors.maxFontSize) {
                    $("html").css("font-size", "+=2");
                    localStorage.fontSize = fontSize+'px';
                }
            });

            $("[data-action='reset-font']").click(function () {
                $("html").css("font-size", self.selectors.baseFontSize);
                localStorage.fontSize = self.selectors.baseFontSize;
            });

            $("[data-action='decrease-font']").click(function () {
                let fontSize = (self.getSize() - self.selectors.resizingStep);

                if (fontSize >= self.selectors.minFontSize) {
                    $("html").css("font-size", "-=2");
                    localStorage.fontSize = fontSize + 'px';
                }
            });
        },
        getSize() {
            size = $("html").css("font-size");
            return parseInt(size, 10);
        }
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

$(document).ready(function () {
    ResizeFonts.init();
});